import { createStyles, makeStyles } from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Tooltip,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useState } from "react";
import { useMutation } from "react-query";
import { ColumnModel } from "../../../models/common.model";
import { FilterRegister } from "../../../models/loan.model";

import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import Fuse from "fuse.js";
import { differenceWith } from "lodash";
import { toast } from "react-toastify";
import { GetRolesByOfficePostIdResponse } from "../../../models/officePostRole.model";
import {
  AddOfficePostRoles,
  DeleteOfficePostRoles,
  GetRolesByOfficePostId,
} from "../../../services/officePostRole.service";
import TabsEmptyStyle from "./TabsEmptyStyle";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);

const columns: readonly ColumnModel[] = [
  { id: "title", label: "نقش سازمانی" },
  { id: "createDatePersian", label: "تاریخ ایجاد" },
  {
    id: "creatorFullName",
    label: "کاربر ایجاد کننده",
  },
  {
    id: "modifyDatePersian",
    label: "تاریخ ویرایش",
  },
  {
    id: "modifierUserFullName",
    label: "کاربر ویرایش کننده",
  },
];
interface TableCmpPropsInterface {
  id: number;
  setAddRoleModal: (state: boolean) => void;
}

function AddRoleTable({ id, setAddRoleModal }: TableCmpPropsInterface) {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");

  const [
    supplierSettlementRequestKeys,
    setSupplierSettlementRequestKeys,
  ] = useState<string[]>([]);

  const [data, setData] = React.useState<GetRolesByOfficePostIdResponse[]>([]);
  const [allData, setAllData] = React.useState<
    GetRolesByOfficePostIdResponse[]
  >([]);
  const [playlistData, setPlaylistData] = React.useState<
    GetRolesByOfficePostIdResponse[]
  >([]);

  const [assignedIds, setAssignedIds] = useState<
    GetRolesByOfficePostIdResponse[]
  >([]);
  const [notAssignedIds, setNotAssignedIds] = useState<
    GetRolesByOfficePostIdResponse[]
  >([]);

  function addAllData() {
    setPlaylistData(allData);
    setData([]);

    data.map((item: any) => {
      let keys: any = supplierSettlementRequestKeys;
      keys.push(item.key);
      setSupplierSettlementRequestKeys(keys);
    });
  }

  function removeAllData() {
    setPlaylistData([]);
    setData(allData);
  }
  function addInPlayList(value: any) {
    setPlaylistData([...playlistData, value]);
    setData(data.filter((item) => item.id !== value.id));
  }

  function removeFromPlayList(value: any) {
    setPlaylistData(playlistData.filter((item) => item.id !== value.id));
    setData([...data, value]);
  }
  React.useEffect(() => {
    GetRolesByOfficePostIdMutate({
      officePostId: id,
    });
  }, []);

  const { mutate: GetRolesByOfficePostIdMutate } = useMutation(
    GetRolesByOfficePostId,
    {
      onSuccess: (result: GetRolesByOfficePostIdResponse[]) => {
        if (result) {
          setAssignedIds(result.filter((item) => item.isAssigned === true));
          setNotAssignedIds(result.filter((item) => item.isAssigned === false));
          setData(result.filter((item) => item.isAssigned === false));
          setPlaylistData(result.filter((item) => item.isAssigned === true));
          setAllData(result);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: AddOfficePostRolesMutate } = useMutation(AddOfficePostRoles, {
    onSuccess: (result: boolean) => {
      if (result) {
        toast.success("تغییرات با موفقیت اضافه گردید");
        setAddRoleModal(false);
      }
    },
    onError: () => {},
  });
  const { mutate: DeleteOfficePostRolesMutate } = useMutation(
    DeleteOfficePostRoles,
    {
      onSuccess: (result: boolean) => {
        if (result) {
          toast.success("تغییرات با موفقیت حذف گردید");
          setAddRoleModal(false);
        }
      },
      onError: () => {},
    }
  );

  const filter = new FilterRegister();
  filter.loanRequestStatus = [];
  filter.loanTemplateIds = [];

  const addOrDelRole = () => {
    const add = differenceWith(notAssignedIds, data).map((item) => item.id);
    const del = differenceWith(assignedIds, playlistData).map(
      (item) => item.id
    );

    if (add.length > 0) {
      AddOfficePostRolesMutate({
        officePostId: id,
        roleIds: add,
      });
    }
    if (del.length > 0) {
      DeleteOfficePostRolesMutate({
        officePostId: id,
        roleIds: del,
      });
    }
  };

  const fuse = new Fuse(data, {
    keys: ["title", "modifierUserFullName", "creatorFullName"],
    includeScore: true,
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
  });
  const results = fuse.search(searchTerm);
  const titleResults = searchTerm ? results.map((title) => title.item) : data;

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };

  return (
    <Box sx={{ width: { xs: "85vw", md: "100%" } }}>
      {/* search */}
      <Box
        sx={{
          marginBottom: "10px",
          width: "100%",
          height: "10%",
        }}
      >
        <Grid item xs={12} width={"300px"}>
          <Paper
            elevation={0}
            style={{
              border: "1px solid #DAE0E4",
              display: "flex",
            }}
            square={false}
          >
            <InputBase
              sx={{ ml: 1, flex: 1, paddingX: "16px" }}
              placeholder="جستجو"
              onChange={handleSearchInput}
            />

            <IconButton
              type="button"
              sx={{ color: "#9AAFC4" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
      </Box>
      {/* top table */}
      <div
        className="cardTableBorder"
        style={{
          maxHeight: "334px",
          marginBottom: "35px",
          height: "30%",
          width: "100%",
          maxWidth: "800px",
        }}
      >
        <TableContainer
          style={{
            background: "#fff",
            height: "310px",
            maxHeight: "334px",
          }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft cursorPointer`}
                // selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight "
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  <Tooltip arrow title="انتخاب همه">
                    <Button
                      className=" colorTitle textFont12 fontWeight "
                      onClick={() => {
                        addAllData();
                      }}
                      style={{
                        textAlign: "center",
                        fontWeight: "bolder",
                      }}
                    >
                      <PlaylistAddIcon style={{ background: "transparent" }} />
                    </Button>
                  </Tooltip>
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {titleResults
                ? titleResults.map((row: any, rowIndex: any) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft  noWrap cursorPointer`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        // key={row.loanRequestId}
                        // selected={selectedRow === rowIndex}
                      >
                        <TableCell
                          className={`colorTitle textFont12 fontWeight backgroundColorTransparet ${
                            rowIndex % 2 === 0 ? "" : "stickyColE"
                          }`}
                          align="right"
                          style={{
                            width: "10vh",
                            minWidth: "10vh",
                            textAlign: "center",
                            fontWeight: "bolder",
                          }}
                          onClick={() => {
                            addInPlayList(row);
                          }}
                        >
                          <Button
                            className=" colorTitle textFont12 fontWeight "
                            style={{
                              textAlign: "center",
                              fontWeight: "bolder",
                            }}
                          >
                            <PlaylistAddIcon
                              style={{ background: "transparent" }}
                            />
                          </Button>
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[
                              column.id as keyof GetRolesByOfficePostIdResponse
                            ];
                          return (
                            <TableCell
                              className="textFont12"
                              key={column.id}
                              align="right"
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value?.toString()}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {/* des */}
      <span
        style={{
          color: "#1D4A87",
          fontSize: "16px",
          fontWeight: "bold",
          marginRight: "15px",
          width: "100%",
          height: "10%",
        }}
      >
        <span
          style={{ color: "#1D4A87", fontSize: "16px", fontWeight: "bold" }}
        >
          لیست منتخب نقش سازمانی &nbsp;
          <span
            style={{
              color: "#1D4A87",
              fontSize: "14px",
              fontWeight: "normal",
            }}
          >
            (
            {playlistData.length !== undefined && playlistData.length != null
              ? playlistData.length
              : 0}{" "}
            مورد){" "}
          </span>
        </span>
      </span>
      {/* bottom table */}
      <div
        className="cardTableBorder"
        style={{
          height: "30%",
          maxHeight: "330px",
          marginBottom: "20px",
          marginTop: "11px",
          width: "100%",
          maxWidth: "800px",
        }}
      >
        {playlistData.length > 0 ? (
          <TableContainer
            style={{
              background: "#fff",
              height: "305px",
              maxHeight: "330px",
            }}
            // className="boxScroll"
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft cursorPointer`}
                  // selected={selectedRow === 0}
                >
                  <TableCell
                    // className="rowTHead colorTitle textFont12 fontWeight stickyColO"
                    align="right"
                    style={{
                      width: "10vh",
                      minWidth: "10vh",
                      backgroundColor: "unset !important",
                    }}
                  >
                    <Tooltip arrow title="لغو همه">
                      <Button
                        className=" colorTitle textFont12 fontWeight"
                        onClick={() => {
                          removeAllData();
                        }}
                        style={{
                          textAlign: "center",
                          fontWeight: "bolder",
                        }}
                      >
                        <img
                          // onClick={exportExcel}
                          className="cursorPointer"
                          style={{
                            width: "17px",
                            height: "17px",
                            marginBottom: ".5vh",
                          }}
                          src="images/RemoveFromPlaylist.svg"
                          alt=""
                        />
                      </Button>
                    </Tooltip>
                  </TableCell>
                  {columns.map((column) => (
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight noWrap"
                      key={column.id}
                      align="right"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {playlistData &&
                  playlistData.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft  noWrap cursorPointer`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        // key={row.loanRequestId}
                        // selected={selectedRow === rowIndex}
                      >
                        <TableCell
                          className={`colorTitle textFont12 fontWeight backgroundColorTransparet ${
                            rowIndex % 2 === 0 ? "" : "stickyColE"
                          }`}
                          align="right"
                          style={{
                            width: "10vh",
                            minWidth: "10vh",
                            textAlign: "center",
                            fontWeight: "bolder",
                          }}
                          onClick={() => {
                            removeFromPlayList(row);
                          }}
                        >
                          <Button
                            className=" colorTitle textFont12 fontWeight"
                            style={{
                              textAlign: "center",
                              fontWeight: "bolder",
                            }}
                          >
                            <img
                              className="cursorPointer"
                              style={{
                                width: "17px",
                                height: "17px",
                                marginBottom: ".5vh",
                                background: "transparent",
                              }}
                              src="images/RemoveFromPlaylist.svg"
                              alt=""
                            />
                          </Button>
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[
                              column.id as keyof GetRolesByOfficePostIdResponse
                            ];
                          return (
                            <TableCell
                              className="textFont12"
                              key={column.id}
                              align="right"
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value?.toString()}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TabsEmptyStyle
            height="32vh"
            completeText="موردی به لیست نقش‌های سازمانی منتخب اضافه نشد"
          />
        )}
      </div>
      {/* final result */}
      <div style={{ width: "100%", height: "20%" }}>
        <Grid container>
          <Grid item xs={0} sm={6} md={6} lg={9}></Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Button
              type="submit"
              onClick={addOrDelRole}
              disabled={
                differenceWith(notAssignedIds, data).map((item) => item.id)
                  .length === 0 &&
                differenceWith(assignedIds, playlistData).map((item) => item.id)
                  .length === 0
              }
              className={
                differenceWith(notAssignedIds, data).map((item) => item.id)
                  .length === 0 &&
                differenceWith(assignedIds, playlistData).map((item) => item.id)
                  .length === 0
                  ? "btnForm disabledBtn  "
                  : "btnForm SuccessDefault "
              }
              style={{ width: "170px" }}
            >
              تایید و ثبت درخواست
            </Button>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}

export default AddRoleTable;
